import apiClient from './client';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8009/api';

export const authAPI = {
  async login(username, password) {
    const response = await fetch(`${API_URL}/auth/token/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Login failed');
    }
    
    return await response.json();
  },
  
  async refreshToken(refreshToken) {
    const response = await fetch(`${API_URL}/auth/token/refresh/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh: refreshToken }),
    });
    
    if (!response.ok) {
      throw new Error('Token refresh failed');
    }
    
    return await response.json();
  },
  
  // ⭐ UPDATED: Fetch current user with groups
  async getCurrentUser() {
    try {
      const response = await apiClient.get('/users/me/');
      const user = response.data;
      
      // ⭐ VALIDATE USER DATA
      if (!user.groups) {
        user.groups = [];
      }
          
      return user;
    } catch (error) {
      throw error;
    }
  },
};
